import React from 'react'

import Socure from '../../Socure/Socure.container'
import { FormComponentProps } from '../../FormContainer/types'

import { AlmostThereComponent } from './AlmostThere.component'
import { AlmostThereFormValues } from './types'

export const AlmostThereContainer: React.FC<
  FormComponentProps<AlmostThereFormValues>
> = ({ formData, navigateStep, setFormData, error }) => {
  return (
    <>
      <Socure context="application submission" />
      <AlmostThereComponent
        navigateStep={navigateStep}
        formData={formData}
        setFormData={setFormData}
        error={error}
      />
    </>
  )
}
